import { Backdrop, CircularProgress } from "@mui/material";

const Loading = ({ isLoading }) => {
  return (
    <Backdrop sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })} open={isLoading}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default Loading;
